<template>
    <ul :class="['breadcrumbs','white']">  

            <template v-if="this.$route.path=='/categories/New'">
                <li class="font-small">
                    <router-link :to="{ path: '/categories/New'}">
                        <span>Latest Updates</span>
                    </router-link>
                </li>            
            </template>
            <template v-else>
                <li class="font-small">                    
                    <router-link :to="{ path: '/categories/New'}">
                        <span style="margin:0px;">Home</span>
                    </router-link>
                    <!-- <router-link :to="{ name: 'home'}">Home</router-link> -->
                </li>
                <!-- <li>
                    <router-link  :to="{ name: 'all'}">
                        <span>></span> <span>All</span>
                    </router-link>
                </li> -->
                <li v-for="crumb in breadCrumbs" :key="crumb.name" class="font-small">
                    <router-link :to="{ name: crumb.name, params: crumb.params }">
                        <span>/</span>
                        <span>{{ crumb.label }}</span>
                    </router-link>
                </li>
            </template>
		</ul>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    props: ['theme'],
    computed: {
        ...mapGetters([
            'breadCrumbs'
        ])
    }
}
</script>




<style lang="stylus">
.breadcrumbs
    padding 0 55px 0 55px
    margin 0
    list-style none
    /.intro &
        position absolute
        top 0px        
    li
        opacity 0.7
        display inline-block
        margin-right 3px
        transition opacity 200ms ease
        a
            height 100%
            display inline-block
            vertical-align middle
            color #fff
            //font-size 14px
            &:before
                content ''
                display inline-block
                height 100%
                vertical-align middle
        span
            display inline-block
            vertical-align middle
            line-height 1
            &:first-child
                //font-size 12px
                margin-right 5px
        &:last-child
            a
                color #646d71
                cursor default
                pointer-events none
        &:hover:not(:last-child)
            // li:not(:last-child)
            opacity 1

    &.white
        a
        :last-child
            color #999
        :first-child
            color #000

</style>

<style>
	@media screen and (max-width:815px) {
		.intro .breadcrumbs {
			position: relative;
			padding: 0px 0px 40px 20px;
		}
        .breadcrumbs {
            padding: 0 20px 0 20px;
        }
	}
</style>